<meta name="viewport" content="width=device-width,initial-scale=1">
<div class="container" id="main-content" aria-label="Main Content">

    <div class="btn-group confirmation-buttons-group" *ngIf="respondeCode == 00">
        <button class="btn btn-primary confirmation-buttons" (click)="print();">
            <span class="material-icons">
                print
            </span>
        </button>
    </div>

    <div class="row" *ngIf="loadIssue">
        <div class="col-md-12">
            <p class="alert-danger" [innerHTML]="'COMMON.LOAD_ISSUE' | translate"></p>
        </div>
    </div>

    <div *ngIf="!loadIssue">
        <div>
            <h1 tabindex="0" class="heading-title" *ngIf="respondeCode == 00">{{'CONFIRMATION.TITLE'| translate}}</h1>
            <hr />
        </div>

        <div class="row" *ngIf="respondeCode == 00">
            <div class="col-md-8">
                <!-- confirmation-->
                <div class="card">
                    <div class="card-body">
                        <p class="text-center sub-heading">{{'CONFIRMATION.CONFIRMATION_THANKS'| translate}}</p>
                        <hr />
                        <ul>
                            <li class="row">
                                <div class="summary-label col-sm-4"><span>{{'COMMON.SERVICE' | translate}}</span></div>
                                <div class="summary-value col-sm-8">{{checkoutInfo[0]?.service_name | translateSplit}}
                                </div>
                            </li>
                        </ul>

                        <ul *ngFor='let booking of checkoutInfo; index as i'>
                            <p class="sub-heading">
                                <b>{{'COMMON.APPLICATION_DETAILS'| translate:{applicantNo: i+1} }}</b></p>

                            <li class="row">
                                <div class="summary-label col-sm-4">
                                    <span>{{'CONFIRMATION.BOOKING_REF' | translate}}</span></div>
                                <div class="summary-value col-sm-8">{{booking?.id}}</div>
                            </li>

                            <li class="row">
                                <div class="summary-label col-sm-4"><span>{{'COMMON.DATE' | translate}}</span></div>
                                <div class="summary-value col-sm-8">{{booking?.datetime | date: 'EEEE d MMMM yyyy'}}
                                </div>
                            </li>

                            <li class="row" tabindex="0">
                                <div class="summary-label col-sm-4"><span>{{'COMMON.TIME' | translate}}</span></div>
                                <div class="summary-value col-sm-8">{{booking?.datetime | date: 'HH:mm'}}</div>
                            </li>

                            <li class="row" tabindex="0">
                                <div class="summary-label col-sm-4"><span>{{'COMMON.COUNTER' | translate}}</span></div>
                                <div class="summary-value col-sm-8">{{booking?.resource_name | translateSplit}}</div>
                            </li>

                            <li class="row" tabindex="0">
                                <div class="summary-label col-sm-4">
                                    <span>{{'CONFIRMATION.APPLICANT_NAME' | translate}}</span>
                                </div>
                                <div class="summary-value col-sm-8">
                                    <!-- Displays the forename 1 -->
                                    <span *ngFor="let answer of booking._embedded.answers;">
                                        <span *ngIf="answer.question_id == 23">{{answer.value}} </span>
                                    </span>

                                    <!-- Displays the forename 2 -->
                                    <span *ngFor="let answer of booking._embedded.answers;">
                                        <span *ngIf="answer.question_id == 24"> {{answer.value}} </span>
                                    </span>

                                    <!-- Displays the surname -->
                                    <span *ngFor="let answer of booking._embedded.answers;">
                                        <span *ngIf="answer.question_id == 22">{{answer.value}} </span>
                                    </span>
                                </div>
                            </li>

                            <li class="row" tabindex="0" *ngFor="let answer of booking._embedded.answers;">
                                <div *ngIf="answer.question_id == 11" class="summary-label col-sm-4">
                                    <span>{{'CONFIRMATION.APPLICATION_TYPE' | translate}}</span>
                                </div>
                                <div *ngIf="answer.question_id == 11" class="summary-value col-sm-8">
                                    {{answer.value | translateSplit}}
                                </div>
                            </li>
                            
                            <li class="row" tabindex="0">
                                <div class="summary-label col-md-4 col-sm-4">
                                    <span>{{'COMMON.COST' | translate}}</span>
                                </div>
                                <div class="summary-value col-md-8 col-sm-8">
                                    {{(booking.price / 100) | currency:'EUR': 'symbol'}}
                                </div>
                            </li>
                        </ul>

                        <hr />

                        <ul>
                            <li class="row" tabindex="0">
                                <div class="summary-label col-md-4 col-sm-4">
                                    <span>{{'COMMON.TOTAL_PAID' | translate}}</span>
                                </div>
                                <div class="summary-value col-md-8 col-sm-8">
                                    <strong>{{ (purchase?.paid/ 100) |  currency:'EUR': 'symbol' }}</strong>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <mat-card>
                    <mat-card-content *ngIf="store?.selectedLocation">
                        <!-- map -->
                        <leaflet-map [lat]="store?.selectedLocation.address.lat"
                            [long]="store?.selectedLocation.address.long" [index]="1">
                        </leaflet-map>
                        <p *ngIf="globals.blLanguage == 0">
                            {{store?.selectedLocation.address.address1 | translateSplit}}<br>
                            {{store?.selectedLocation.address.address2 | translateSplit}}<br>
                            <span
                                *ngIf="store?.selectedLocation.address.address3">{{store?.selectedLocation.address.address3 | translateSplit}}<br></span>
                            {{store?.selectedLocation.address.address4 | translateSplit}}<br> {{store?.selectedLocation.address.postcode
                            | translateSplit}}<br> {{store?.selectedLocation.address.country | translateSplit}}
                        </p>

                        <p *ngIf="globals.blLanguage == 1">
                            <span *ngFor="let addressPart of store?.irishAddress;">
                                {{addressPart}}<br></span>
                        </p>
                    </mat-card-content>
                </mat-card>
            </div>

        </div>

        <div class="row" *ngIf="respondeCode == 'unknown'">
            <p class="col-sm-12 failed-payment-msg">{{'CONFIRMATION.UNSUCCESSFUL_PAYMENT' | translate}}</p>
            <p class="col-sm-12 text-center">{{'CONFIRMATION.CHARGED' | translate}}</p>
        </div>
    </div>
</div>